var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIntegration = function SvgIntegration(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    viewBox: "0 0 12 13.4",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.2,
    height: 12.533,
    x: 0.4,
    y: 0.4,
    stroke: "currentColor",
    strokeWidth: 0.8,
    rx: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M4.667 3.334 3.334 4.667 4.667 6M3.334 4.667h5.333M7.333 10l1.333-1.333-1.333-1.334M8.667 8.667H3.332"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIntegration);
export default ForwardRef;